<template>
  <div class="p-2 rounded-xl min-h-screen">
    <div
        class="bg-white bg-opacity-70 backdrop-filter backdrop-blur-lg rounded-xl p-3 mb-6 shadow-sm border border-gray-100 relative z-30">
      <div class="flex flex-wrap items-center gap-2">
        <div class="relative w-32">
          <input
              v-model="filters.search_value"
              placeholder="نام"
              class="px-2 py-1.5 bg-gray-100 text-xs rounded-lg border w-full text-right"
              @keyup.enter="applyFilters"
          >
        </div>
        <div class="relative w-32">
          <input
              v-model="filters.sku"
              placeholder="SKU"
              class="px-2 py-1.5 bg-gray-100 text-xs rounded-lg border w-full text-right"
              @keyup.enter="applyFilters"
          >
        </div>
        <div class="relative w-32">
          <input
              v-model="filters.id_in"
              placeholder="شناسه"
              class="px-2 py-1.5 bg-gray-100 text-xs rounded-lg border w-full text-right"
              @keyup.enter="applyFilters"
          >
        </div>
        <div class="flex gap-1 w-48">
          <input
              v-model="filters.min_inventory"
              placeholder="حداقل موجودی"
              class="px-2 py-1.5 bg-gray-100 text-xs rounded-lg border w-full text-right"
              type="number"
              @keyup.enter="applyFilters"
          >
          <input
              v-model="filters.max_inventory"
              placeholder="حداکثر موجودی"
              class="px-2 py-1.5 bg-gray-100 text-xs rounded-lg border w-full text-right"
              type="number"
              @keyup.enter="applyFilters"
          >
        </div>
        <searchable-select v-model="filters.brand_in" :options="brands"
                           placeholder="همه برندها"
                           class="w-32 backdrop-blur-xl"
                           style="z-index: 999999"
                           @change="applyFilters"
        ></searchable-select>
        <select
            @change="applyFilters"
            v-model="filters.currency_in"
            class="px-2 py-1.5 bg-gray-100 text-xs rounded-lg border w-32 text-right "
        >
          <option value="">همه ارزها</option>
          <option
              v-for="currency in currencies"
              :key="currency.id"
              :value="currency.id"
          >
            {{ currency.name }}
          </option>
          <option value="null">بدون ارز</option>
        </select>
        <div class="flex gap-1">
          <button
              @click="resetFilters"
              class="p-1.5 px-2 bg-gradient-to-r from-gray-500 to-blue-600 text-white rounded-full shadow-sm hover:shadow-md transition-all duration-300 transform hover:scale-105"
              title="حذف فیلترها"
          >
            <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24"
                 stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"/>
            </svg>
          </button>
          <button
              @click="applyFilters"
              class="py-1.5 px-2 bg-gradient-to-r from-red-500 to-blue-600 text-white rounded-full shadow-sm hover:shadow-md transition-all duration-300 transform hover:scale-105"
              title="اعمال فیلتر"
          >
            <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24"
                 stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z"/>
            </svg>
          </button>
          <button
              @click="refreshProducts"
              class="p-2 mr-2 bg-white rounded-lg shadow-sm hover:shadow-md transition-all duration-300 hover:bg-gray-50 transform hover:scale-105"
          >
            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-gray-600" fill="none" viewBox="0 0 24 24"
                 stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"/>
            </svg>
          </button>

        </div>
      </div>
    </div>
    <!-- Table -->
    <div
        class="bg-white bg-opacity-70 backdrop-filter backdrop-blur-lg rounded-xl shadow-sm border border-gray-100"
        ref="listRoot">
      <div class="overflow-x-auto" ref="tableWrap">
        <table class="min-w-full text-sm">
          <thead class="bg-gray-50 bg-opacity-70">
          <tr>
            <th class="p-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">شناسه</th>
            <th class="p-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">SKU</th>
            <th class="p-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">محصول</th>
            <th class="p-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">نوع</th>
            <th class="p-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">قیمت</th>
            <th class="p-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">موجودی</th>
            <th class="p-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">برند</th>
            <th class="p-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">ارز</th>
            <th class="p-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider"></th>
            <th class="p-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider"></th>
            <th class="p-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider"></th>
            <th class="p-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider"></th>
            <th class="p-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider"></th>
            <th class="p-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider"></th>
          </tr>
          </thead>
          <tbody>
          <tr v-if="loading">
            <td colspan="6" class="p-4 text-center">
              <div class="flex justify-center items-center gap-2">
                <svg class="animate-spin h-5 w-5 text-blue-500" xmlns="http://www.w3.org/2000/svg" fill="none"
                     viewBox="0 0 24 24">
                  <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                  <path class="opacity-75" fill="currentColor"
                        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                </svg>
                در حال بارگذاری...
              </div>
            </td>
          </tr>
          <tr v-else-if="products.length === 0">
            <td colspan="6" class="p-4 text-center text-gray-500">
              محصولی یافت نشد
            </td>
          </tr>
          <template v-else v-for="product in products">
            <tr
                v-if="product.product_type === 'variable' && expandedRows[product.id]"
                class="pointer-events-none"
            >
              <td colspan="12" class="p-0">
                <div class="h-[50px]"></div>
              </td>
            </tr>
            <tr
                :key="product.id + '-row1'"
                :ref="'row-' + product.id"
                :class="(product.product_type === 'variable' && expandedRows[product.id]) ? 'border-t-4  border-t border-gray-300 border-b border-b-gray-300 bg-blue-900/40 transition-colors duration-200':'border-t border-gray-100 hover:bg-gray-50 transition-colors duration-200'"
            >
              <td class="p-3 font-medium text-[9px] text-gray-900">{{ product.id || ' بدون شناسه' }}</td>
              <td class="p-3 font-medium text-[9px] text-gray-900" v-if="product.skus.length === 1">
                {{ product.sixteen_digit_code || ' بدون کد' }}
              </td>
              <td class="p-3 font-medium text-[9px] text-gray-900" v-else>
                <p v-for="sku in product.skus"> {{ sku }}</p>
              </td>
              <td class="p-3">
                <div class="flex items-center gap-3">
                  <div class="relative" v-if="product.image">
                    <img
                        :src="img_source(product.image)"
                        class="w-10 h-10 rounded-lg object-cover border border-gray-200 shadow-sm"
                    >
                  </div>
                  <div class="min-w-0">
                    <div
                        class="text-[9px] font-medium text-gray-900 leading-4
                 whitespace-normal break-words max-w-[150px]"
                    >
                      {{ product.name }}
                    </div>
                    <div class="text-[9px] text-gray-500 mt-1">
                      {{ product.sixteen_digit_code }}
                    </div>
                    <div
                        class="text-[9px] text-gray-500 mt-1 flex items-center gap-1"
                        v-if="product.product_type == 'variation'"
                    >
                      <svg xmlns="http://www.w3.org/2000/svg" class="h-3 w-3" fill="none" viewBox="0 0 24 24"
                           stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                              d="M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z"/>
                      </svg>
                      {{ product.variation_of_name }}
                    </div>
                  </div>
                </div>
              </td>
              <td class="p-3">
                  <span
                      class="px-2.5 py-1 rounded-full text-[8px] font-medium"
                      :class="{
                      'bg-green-100 text-green-800': product.product_type === 'simple',
                      'bg-blue-100 text-blue-800': product.product_type === 'variable',
                      'bg-red-100 text-red-800': product.product_type === 'variation'
                    }"
                  >
                    {{ getTypeLabel(product.product_type) }}
                  </span>
              </td>
              <td class="p-3" v-if="product.product_type != 'variable'">
                <div class="text-[9px] font-medium text-gray-900">{{ product.price | toMoney }} تومان</div>
                <div v-if="product.regular_price > product.price" class="text-[8px] text-green-600 line-through mt-1">
                  {{ product.regular_price | toMoney }}
                  تومان
                </div>
              </td>
              <td class="p-3 align-center" v-else>
                <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 transform transition-transform duration-200"
                     fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"/>
                </svg>
              </td>
              <td class="p-3 text-[9px]">
                <div class="flex items-center gap-1"
                     v-if="product.calculate_current_inventory == 0">
                  <span class=" text-red-600 .5 rounded-full text-[7px] font-medium">
                     اتمام موجودی
                  </span>
                </div>
                <div class="flex items-center gap-1 text-[9px]"
                     v-if="product.calculate_current_inventory > 0">
                  {{ product.calculate_current_inventory | toMoney }}
                  <span class="text-xs text-gray-500 text-[7px]">عدد</span>
                </div>
              </td>
              <td class="p-3">
                <span class="text-[9px]" v-if="product.brand">{{ product.brand.name }}</span>
              </td>
              <td class="p-3 truncate-text">
                <span class="text-[9px] ">{{ product.currency_name }}</span>
              </td>
              <td class="p-3 text-left relative">
                <button
                    v-if="product.product_type != 'variable'"
                    class=" items-center bg-white/10 rounded-lg  px-3 py-2 hover:bg-gray-50 text-center"
                    @click.stop="openLabelPrice(product.id, 'html')"
                >
                  <span>پرینت لیبل قیمت</span>
                </button>
              </td>
              <td class="p-3 text-left relative">
                <button
                    v-if="product.product_type != 'variable'"
                    class=" items-center bg-white/10 rounded-lg  px-3 py-2 hover:bg-gray-50 text-center"
                    @click.stop="openLabelGTN(product.id, 'html')"
                >
                  <span> لیبل GTN  بدون قیمت</span>
                </button>
              </td>
              <td class="p-3 text-left relative">
                <button
                    v-if="product.product_type != 'variable'"
                    class=" items-center bg-white/10 rounded-lg  px-3 py-2 hover:bg-gray-50 text-center"
                    @click.stop="openLabelShelf(product.id, 'html')"
                >
                  <span>پرینت لیبل شلف</span>
                </button>
              </td>
              <td>
                <button
                    v-if="product.product_type != 'variable'"
                    class=" items-center bg-white/10 rounded-lg  px-3 py-2 hover:bg-gray-50 text-center"
                    @click.stop="openإBarcodePrice(product.id, 'html')"
                >
                  <span>پرینت بارکد و قیمت</span>
                </button>
              </td>
              <td>
                <button
                    v-if="product.product_type != 'variable'"
                    class=" items-center bg-white/10 rounded-lg  px-3 py-2 hover:bg-gray-50 text-center"
                    @click.stop="openQr(product.id, 'html')"
                >
                  <span>پرینت QRCode</span>
                </button>
              </td>
              <td>
                <button
                    v-if="product.product_type != 'variable'"
                    class=" items-center bg-white/10 rounded-lg  px-3 py-2 hover:bg-gray-50 text-center"
                    @click.stop="openTest(product.id, 'html')"
                >
                  <span>پرینت Tester</span>
                </button>
              </td>
              <td>

                <button
                    v-if="product.product_type != 'variable'"

                    class=" items-center bg-white/10 rounded-lg  px-3 py-2 hover:bg-gray-50 text-center"
                    @click.s.stop="openLabel(product.id, 'html')"
                >
                  <span>پرینت بارکد</span>
                </button>
              </td>

            </tr>
            <tr
                v-if="product.product_type === 'variable' && expandedRows[product.id] && v.active ==true"
                v-for="(v, idx) in product.variations"
                @click.stop="openVariationPopup(product, v)"
                :key="v.id || v.sixteen_digit_code || v.name"
                :class="(idx === product.variations.length - 1 ) ? 'border-b-4  border-b border-b-gray-300':''"
                class="border-t border-t-gray-100 bg-gray-100 hover:bg-gray-200 cursor-pointer transition-colors duration-200">

              <td class="p-3 font-medium text-[9px] text-gray-900">{{ v.id || ' بدون شناسه' }}</td>
              <td class="p-3 font-medium text-[9px] text-gray-900">{{ v.sixteen_digit_code || ' بدون کد' }}
              </td>
              <td class="p-3">
                <div class="flex items-center gap-3">
                  <div class="relative" v-if="v.image">
                    <img
                        :src="img_source(v.image)"
                        class="w-10 h-10 rounded-lg object-cover border border-gray-200 shadow-sm"
                    >
                  </div>
                  <div class="min-w-0">
                    <div
                        class="text-[9px] font-medium text-gray-900 leading-4
                 whitespace-normal break-words max-w-[150px]"
                    >
                      {{ v.name }}
                    </div>
                  </div>
                </div>
              </td>
              <td class="p-3">
                  <span
                      class="px-2.5 py-1 rounded-full text-[8px] font-medium bg-red-100 text-red-800"
                  >
                    {{ getTypeLabel('variation') }}
                  </span>
              </td>
              <td class="p-3">
                <div class="text-[9px] font-medium text-gray-900">{{ v.price | toMoney }} تومان</div>
                <div v-if="v.regular_price > v.price" class="text-[8px] text-green-800 line-through mt-1">
                  {{ v.regular_price | toMoney }}
                  تومان
                </div>
              </td>
              <td class="p-3 text-[9px]">
                <div class="flex items-center gap-1"
                     v-if="v.calculate_current_inventory == 0">
                  <span class=" text-red-600 .5 rounded-full text-[7px] font-medium">
                     اتمام موجودی
                  </span>
                </div>
                <div class="flex items-center gap-1 text-[9px]"
                     v-if="v.calculate_current_inventory > 0">
                  {{ v.calculate_current_inventory | toMoney }}
                  <span class="text-xs text-gray-500 text-[7px]">عدد</span>
                </div>
              </td>
              <td></td>
              <td></td>

              <td class="p-3 text-left relative">
                <button
                    class=" items-center bg-white/10 rounded-lg  px-3 py-2 hover:bg-gray-50 text-center"
                    @click.stop="openLabelPrice(v.id, 'html')"
                >
                  <span>پرینت لیبل قیمت</span>
                </button>
              </td>
              <td class="p-3 text-left relative">
                <button
                    class=" items-center bg-white/10 rounded-lg  px-3 py-2 hover:bg-gray-50 text-center"
                    @click.stop="openLabelGTN(v.id, 'html')"
                >
                  <span> لیبل GTN  بدون قیمت</span>
                </button>
              </td>
              <td class="p-3 text-left relative">
                <button
                    class=" items-center bg-white/10 rounded-lg  px-3 py-2 hover:bg-gray-50 text-center"
                    @click.stop="openLabelShelf(v.id, 'html')"
                >
                  <span>پرینت لیبل شلف</span>
                </button>
              </td>
              <td>
                <button
                    class=" items-center bg-white/10 rounded-lg  px-3 py-2 hover:bg-gray-50 text-center"
                    @click.stop="openإBarcodePrice(v.id, 'html')"
                >
                  <span>پرینت بارکد و قیمت</span>
                </button>
              </td>
              <td>
                <button
                    class=" items-center bg-white/10 rounded-lg  px-3 py-2 hover:bg-gray-50 text-center"
                    @click.stop="openQr(v.id, 'html')"
                >
                  <span>پرینت QRCode</span>
                </button>
              </td>
              <td>
                <button
                    class=" items-center bg-white/10 rounded-lg  px-3 py-2 hover:bg-gray-50 text-center"
                    @click.stop="openTest(v.id, 'html')"
                >
                  <span>پرینت Tester</span>
                </button>
              </td>

              <td>

                <button
                    class=" items-center bg-white/10 rounded-lg  px-3 py-2 hover:bg-gray-50 text-center"
                    @click.s.stop="openLabel(v.id, 'html')"
                >
                  <span>پرینت بارکد</span>
                </button>
              </td>
            </tr>
            <tr
                v-if="product.product_type === 'variable' && expandedRows[product.id]"
                class="pointer-events-none"
            >
              <td colspan="12" class="p-0">
                <div class="h-[50px]"></div>
              </td>
            </tr>
          </template>
          </tbody>
        </table>
      </div>
      <div class=" p-4 border-t border-gray-100 flex flex-col md:flex-row justify-between items-center gap-4">
        <div class="flex items-center gap-2 ml-auto">
          <label class="text-xs text-gray-600">تعداد در هر صفحه:</label>
          <select
              v-model.number="itemsPerPage"
              @change="changePerPage"
              class="px-2 py-1.5 bg-gray-100 text-xs rounded-lg border w-24 text-right"
          >
            <option :value="10">10</option>
            <option :value="20">20</option>
            <option :value="50">50</option>
            <option :value="100">100</option>
          </select>
        </div>
        <div class="text-sm text-gray-600">
          نمایش {{ (currentPage - 1) * itemsPerPage + 1 }} تا
          {{ Math.min(currentPage * itemsPerPage, totalProducts) }} از
          {{ totalProducts }} محصول
        </div>
        <div class="flex gap-1">
          <button
              @click="prevPage"
              :disabled="currentPage === 1"
              class="p-2 border border-gray-200 rounded-lg bg-white bg-opacity-50 hover:bg-gray-50 transition-colors duration-200 disabled:opacity-50 disabled:cursor-not-allowed"
              :class="{ 'opacity-50 cursor-not-allowed': currentPage === 1 }"
          >
            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24"
                 stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"/>
            </svg>
          </button>
          <button
              v-for="page in visiblePages"
              :key="page"
              @click="goToPage(page)"
              class="p-2 text-center border border-gray-200 rounded-full transition-colors duration-200"
              :class="{
              'bg-gradient-to-r from-blue-500/60 to-blue-600/50 text-white shadow-md': page === currentPage,
              'bg-white bg-opacity-50 hover:bg-gray-50': page !== currentPage,
              'cursor-default': page === '...'
            }"
              :disabled="page === '...'"
          >
            {{ page }}
          </button>
          <button
              @click="nextPage"
              :disabled="currentPage * itemsPerPage >= totalProducts"
              class="p-2 border border-gray-200 rounded-lg bg-white bg-opacity-50 hover:bg-gray-50 transition-colors duration-200 disabled:opacity-50 disabled:cursor-not-allowed"
              :class="{ 'opacity-50 cursor-not-allowed': currentPage * itemsPerPage >= totalProducts }"
          >
            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24"
                 stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7"/>
            </svg>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import SearchableSelect from "@/components/selects/SearchableSelect";
import AdminProductNewCat from "@/modules/product_admin/AdminProductNewCat";

export default {
  name: 'ProductLabelTable',
  components: {AdminProductNewCat, SearchableSelect},
  data() {
    return {
      _lastFetchId: 0,
      openLabelMenuId: null,
      initialProgressFromQuery: null,
      appliedInitialProgress: false,
      navigatingOut: false,
      _rafTick: null,
      _progressCache: 0,
      _scrollContainer: null,
      editingVariation: null,
      editingProductId: null,
      expandedRows: {},
      openActionMenuId: null,
      actionMenuProduct: null,
      actionMenuPos: {top: '0px', left: '0px'},
      needRestore: false,
      showQuickView: false,
      showQuickEdit: false,
      showVariationForm: false,
      showQuickCatalog: false,
      selectedProduct: null,
      selectedProductId: null,
      loading: true,
      products: [],
      totalProducts: 0,
      currentPage: 1,
      itemsPerPage: 10,
      filters: {
        id_in: '',
        search_value: '',
        sku: '',
        min_price: '',
        max_price: '',
        min_inventory: '',
        max_inventory: '',
        category_tree: '',
        brand_in: '',
        status_in: '',
        content_status: '',
        catalog_need: '',
        currency_in: '',
        is_ai: null,
        supplier: ''
      },
      categories: [],
      brands: [],
      avails: [],
      features: [],
      currencies: []
    }
  },
  created() {
    if ('scrollRestoration' in history) {
      try {
        history.scrollRestoration = 'manual'
      } catch (e) {
      }
    }
    this.needRestore = sessionStorage.getItem('adminProductListRestore') === '1'
  },
  computed: {
    visiblePages() {
      const totalPages = Math.ceil(this.totalProducts / this.itemsPerPage)
      const range = 1
      const pages = []
      pages.push(1)
      if (this.currentPage - range > 2) {
        pages.push('...')
      }
      for (let i = Math.max(2, this.currentPage - range); i <= Math.min(totalPages - 1, this.currentPage + range); i++) {
        pages.push(i)
      }
      if (this.currentPage + range < totalPages - 1) {
        pages.push('...')
      }
      if (totalPages > 1) {
        pages.push(totalPages)
      }
      return pages
    },
    publishedProducts() {
      return this.products.filter(p => p.status === 'publish').length
    },
    totalInventory() {
      return this.products.reduce((sum, product) => sum + product.calculate_current_inventory, 0)
    },
    averagePrice() {
      if (this.products.length === 0) return 0
      const sum = this.products.reduce((sum, product) => sum + product.price, 0)
      return Math.round(sum / this.products.length)
    }
  },
  watch: {
    brands(newVal) {
      if (newVal.length && this.filters.brand_in) {
        this.filters = {...this.filters};
      }
    }
  },
  methods: {
    ensureDefaultExpandedVariables() {
      try {
        const next = {...(this.expandedRows || {})};

        (this.products || []).forEach(p => {
          if (p && p.product_type === 'variable' && p.id != null) {
            // فقط اگر قبلا مقدار نداده بودیم، پیش‌فرض بازش کن
            if (typeof next[p.id] === 'undefined') next[p.id] = true;
          }
        });

        this.expandedRows = next;
      } catch (e) {
      }
    },

    activated() {
      this.navigatingOut = false;
    },

    toggleLabelMenu(productId) {
      this.openLabelMenuId = this.openLabelMenuId === productId ? null : productId;
    },
    openLabel(productId, mode) {
      const baseUrl = this.endpoint(`product/label/${productId}?token=${this.token}`);
      const url = `${baseUrl}&mode=${mode}`;

      if (mode === 'html') {
        window.open(url, '_blank');
      } else {
        window.open(url, '_blank');
      }

      this.openLabelMenuId = null;
    },
    openQr(productId, mode) {
      const baseUrl = this.endpoint(`product/qrCode/${productId}?token=${this.token}`);
      const url = `${baseUrl}&mode=${mode}`;

      if (mode === 'html') {
        window.open(url, '_blank');
      } else {
        window.open(url, '_blank');
      }

      this.openLabelMenuId = null;
    },
    openTest(productId, mode) {
      const baseUrl = this.endpoint(`product/labelForTester/${productId}?token=${this.token}`);
      const url = `${baseUrl}&mode=${mode}`;

      if (mode === 'html') {
        window.open(url, '_blank');
      } else {
        window.open(url, '_blank');
      }

      this.openLabelMenuId = null;
    },
    openLabelPrice(productId, mode) {
      const baseUrl = this.endpoint(`product/priceLabel/${productId}?token=${this.token}`);
      const url = `${baseUrl}&mode=${mode}`;

      if (mode === 'html') {
        window.open(url, '_blank');
      } else {
        window.open(url, '_blank');
      }

      this.openLabelMenuId = null;
    },
    openLabelGTN(productId, mode) {
      const baseUrl = this.endpoint(`product/gtnLabel/${productId}?token=${this.token}`);
      const url = `${baseUrl}&mode=${mode}`;

      if (mode === 'html') {
        window.open(url, '_blank');
      } else {
        window.open(url, '_blank');
      }

      this.openLabelMenuId = null;
    },
    openLabelShelf(productId, mode) {
      const baseUrl = this.endpoint(`product/standLabel/${productId}?token=${this.token}`);
      const url = `${baseUrl}&mode=${mode}`;

      if (mode === 'html') {
        window.open(url, '_blank');
      } else {
        window.open(url, '_blank');
      }

      this.openLabelMenuId = null;
    },
    openإBarcodePrice(productId, mode) {
      const baseUrl = this.endpoint(`product/priceLabelSku/${productId}?token=${this.token}`);
      const url = `${baseUrl}&mode=${mode}`;

      if (mode === 'html') {
        window.open(url, '_blank');
      } else {
        window.open(url, '_blank');
      }

      this.openLabelMenuId = null;
    },


    _getScrollContainer(startEl = this.$el) {
      let el = startEl;
      while (el && el !== document.body && el !== document.documentElement) {
        const style = window.getComputedStyle(el);
        const canScrollY =
            /(auto|scroll|overlay)/.test(style.overflowY) &&
            el.scrollHeight > el.clientHeight;
        if (canScrollY) return el;
        el = el.parentElement;
      }
      return window;
    },
    _scrollToY(container, y, behavior = 'smooth') {
      if (container === window) {
        window.scrollTo({top: y, behavior});
      } else {
        container.scrollTo({top: y, behavior});
      }
    },
    _computeAndCacheProgress({pingUrl = false} = {}) {
      const tableWrap = this.$refs.tableWrap;
      const sc = this._scrollContainer || window;
      if (!tableWrap) return this._progressCache;
      const scIsWindow = (sc === window);
      const docY = window.pageYOffset || document.documentElement.scrollTop || 0;
      const tableRect = tableWrap.getBoundingClientRect();
      const tableTopAbs = tableRect.top + docY;
      const vpH = scIsWindow
          ? (window.innerHeight || document.documentElement.clientHeight || 0)
          : sc.clientHeight;
      const scTopAbs = scIsWindow
          ? 0
          : (sc.getBoundingClientRect().top + docY);
      const tableTopRelToSc = tableTopAbs - scTopAbs;
      const tableHeight = tableRect.height;
      const scrollTopInside = scIsWindow ? docY : sc.scrollTop;
      const passed = Math.max(0, (scrollTopInside - tableTopRelToSc));
      const maxInside = Math.max(0, tableHeight - vpH);
      if (maxInside <= 2) {
        this._progressCache = 0;
        if (pingUrl) this._persistProgressToQuery();
        return 0;
      }
      const p = Math.max(0, Math.min(1, passed / maxInside));
      this._progressCache = p;
      if (pingUrl) this._persistProgressToQuery();
      return p;
    },
    scrollToProgress(progress = 0, behavior = 'smooth') {
      const tableWrap = this.$refs.tableWrap;
      if (!tableWrap) return;
      const sc = this._scrollContainer || this._getScrollContainer(this.$refs.listRoot || this.$el);
      this._scrollContainer = sc;
      const clamped = Math.max(0, Math.min(1, Number(progress) || 0));
      const scIsWindow = (sc === window);
      const docY = window.pageYOffset || document.documentElement.scrollTop || 0;
      const tableRect = tableWrap.getBoundingClientRect();
      const tableTopAbs = tableRect.top + docY;
      const vpH = scIsWindow
          ? (window.innerHeight || document.documentElement.clientHeight || 0)
          : sc.clientHeight;
      const scTopAbs = scIsWindow
          ? 0
          : (sc.getBoundingClientRect().top + docY);
      const tableTopRelToSc = tableTopAbs - scTopAbs;
      const tableHeight = tableRect.height;
      const maxInside = Math.max(0, tableHeight - vpH);
      const targetInside = maxInside * clamped;
      const targetY = tableTopRelToSc + targetInside;
      const stickyOffset = 70;
      this._scrollToY(sc, targetY + stickyOffset, behavior);
    },
    setProgressParam(p) {
      if (this.navigatingOut) return;
      if (this.$route.name !== this.$options.name) return;
      const q = {...this.$route.query, progress: Number((p ?? 0).toFixed(3))};
      this.$router.replace({name: this.$route.name, query: q}).catch(() => {
      });
    },
    clearProgressParam() {
      if (this.navigatingOut) return;
      if (this.$route.name !== this.$options.name) return;
      const q = {...this.$route.query};
      delete q.progress;
      this.$router.replace({name: this.$route.name, query: q}).catch(() => {
      });
    },
    _onScrollRaf() {
      if (this._rafTick) return;
      this._rafTick = requestAnimationFrame(() => {
        this._rafTick = null;
        this._computeAndCacheProgress();
      });
    },
    _persistProgressToQuery() {
      if (this.navigatingOut) return;
      if (this.$route.name !== this.$options.name) return; // فقط وقتی هنوز روی لیست هستیم
      const q = {...this.$route.query};
      const p = Math.max(0, Math.min(1, this._progressCache || 0));
      q.progress = Number(p.toFixed(3));
      this.$router.replace({name: this.$route.name, query: q}).catch(() => {
      });
    },
    fetchFeatures() {
      this.request({
        url: this.endpoint('product/featureTree'), method: 'get',
        success: (data) => {
          this.features = data
        }
      })
    },
    fetchAvails() {
      this.request({
        url: this.endpoint('product/availsTree'),
        method: 'get',
        success: (data) => {
          this.avails = data
        }
      })
    },
    openVariationPopup(product, variation) {
      this.closeActionMenu()
      this.editingProductId = product.id
      this.editingVariation = variation || null
      this.showVariationForm = true
    },
    closeVariationPopup() {
      this.showVariationForm = false
      this.editingVariation = null
      this.editingProductId = null
    },
    onVariationSaved() {
      this.fetchProducts()
      this.closeVariationPopup()
    },
    onVariationChanged() {
      this.fetchProducts()
    },
    onVariationDone() {
      this.fetchProducts()
      this.closeVariationPopup()
    },
    onVariationCancel() {
      this.closeVariationPopup()
    },
    toggleVariationsRow(product) {
      const cur = !!this.expandedRows[product.id]
      this.$set(this.expandedRows, product.id, !cur)
      this.closeActionMenu()
    },
    closeVariationsRow(productId) {
      this.$set(this.expandedRows, productId, false)
    },
    toggleActionMenu(product, evt) {
      if (this.openActionMenuId === product.id) {
        this.closeActionMenu()
        return
      }
      this.actionMenuProduct = product
      this.openActionMenuId = product.id
      try {
        const btn = evt.currentTarget
        const rect = btn.getBoundingClientRect()
        const gap = 8
        let top = rect.bottom + gap - 100
        let left = rect.left
        const menuWidth = 200
        const vw = window.innerWidth
        if (left + menuWidth > vw - 8) left = Math.max(8, vw - menuWidth - 8)
        this.actionMenuPos = {
          top: `${top}px`,
          left: `${left}px`
        }
      } catch (e) {
        this.actionMenuPos = {top: '80px', left: '16px'}
      }
    },
    handleGlobalClick() {
      this.openActionMenuId = null
    },
    closeActionMenu() {
      this.openActionMenuId = null
      this.actionMenuProduct = null
    },
    doQuickView(product) {
      this.closeActionMenu()
      this.selectedProduct = product
      this.showQuickView = true
    },
    doQuickEdit(product) {
      this.closeActionMenu()
      this.selectedProductId = product.id
      this.showQuickEdit = true
    },
    doCatalog(product) {
      this.closeActionMenu()
      this.selectedProductId = product.id
      this.showQuickCatalog = true
    },
    openProductHere(product) {
      this.closeActionMenu();
      this.navigatingOut = true;
      const p = this._computeAndCacheProgress() || 0;
      this.$router.push({
        path: `/panel/adminProductForm/${product.id}`,
        query: {
          ...this.$route.query,
          progress: Number(p.toFixed(3))
        }
      });
    },
    openProductNewTab(product) {
      this.closeActionMenu();
      this.navigatingOut = true;
      const p = this._computeAndCacheProgress() || 0;
      const routeData = this.$router.resolve({
        path: `/panel/adminProductForm/${product.id}`,
        query: {
          ...this.$route.query,
          progress: Number(p.toFixed(3))
        }
      });
      window.open(routeData.href, '_blank');
    },
    handleEditProduct(product) {
      this.openProductHere(product)
    },
    waitForImagesLoaded(rootEl) {
      try {
        const imgs = Array.from(rootEl ? rootEl.querySelectorAll('img') : [])
        if (!imgs.length) return Promise.resolve()
        const waits = imgs.map(img => {
          if (img.complete && img.naturalHeight !== 0) return Promise.resolve()
          return new Promise(res => {
            const done = () => res()
            img.addEventListener('load', done, {once: true})
            img.addEventListener('error', done, {once: true})
          })
        })
        const timeout = new Promise(res => setTimeout(res, 2500))
        return Promise.race([Promise.all(waits), timeout])
      } catch (e) {
        return Promise.resolve()
      }
    },
    restoreScrollRobust() {
      const should = sessionStorage.getItem('adminProductListRestore') === '1'
      if (!should) return
      const target = Number(sessionStorage.getItem('adminProductListScroll') || 0)
      if (isNaN(target)) {
        sessionStorage.removeItem('adminProductListRestore')
        return
      }
      const scrollOnce = () => {
        const maxY = Math.max(
            0,
            (document.documentElement.scrollHeight || document.body.scrollHeight) - window.innerHeight
        )
        const y = Math.min(target, maxY)
        window.scrollTo(0, y)
        return Math.abs((window.scrollY || window.pageYOffset) - y) < 2
      }
      let tries = 0
      const maxTries = 30 // ~3s
      const tick = () => {
        if (scrollOnce()) {
          // برای تلنگر نهایی بعد از لود تأخیری
          setTimeout(scrollOnce, 150)
          sessionStorage.removeItem('adminProductListRestore')
          return
        }
        tries++
        if (tries < maxTries) setTimeout(tick, 100)
        else sessionStorage.removeItem('adminProductListRestore')
      }
      tick()
    },
    loadStateFromQuery() {
      const q = this.$route.query || {};

      const strKeys = [
        'id_in',
        'search_value',
        'sku',
        'category_tree',
        'status_in',
        'content_status'
      ];

      strKeys.forEach(k => {
        if (q[k] != null) this.filters[k] = q[k];
      });

      const intKeysForFilters = [
        'min_price',
        'max_price',
        'min_inventory',
        'max_inventory',
        'brand_in',
        'currency_in',
        'supplier'
      ];

      intKeysForFilters.forEach(k => {
        if (q[k] != null && q[k] !== '') {
          const n = Number(q[k]);
          if (!isNaN(n)) {
            this.filters[k] = n;
          }
        }
      });

      if (q.page != null && q.page !== '') {
        const p = Number(q.page);
        if (!isNaN(p)) this.currentPage = p;
      }
      if (q.per_page != null && q.per_page !== '') {
        const pp = Number(q.per_page);
        if (!isNaN(pp)) this.itemsPerPage = pp;
      }

      if (q.catalog_need != null) {
        if (q.catalog_need === 'true') this.filters.catalog_need = true;
        else if (q.catalog_need === 'false') this.filters.catalog_need = false;
        else this.filters.catalog_need = '';
      }

      if (q.progress != null && q.progress !== '') {
        const p = Number(q.progress);
        if (!isNaN(p)) {
          this.initialProgressFromQuery = Math.max(0, Math.min(1, p));
        }
      }
    },
    persistStateToQuery(replace = true) {
      if (this.navigatingOut) return;
      if (this.$route.name !== this.$options.name) return;

      const rawQuery = {
        ...Object.fromEntries(
            Object.entries(this.filters).map(([k, v]) => [k, v ?? ''])
        ),
        page: this.currentPage,
        per_page: this.itemsPerPage,
      };

      const query = {};
      Object.keys(rawQuery).forEach(k => {
        const v = rawQuery[k];
        if (v !== '' && v != null) {
          query[k] = v;
        }
      });

      const current = this.$route.query || {};
      const sameQuery = JSON.stringify(current) === JSON.stringify(query);
      if (sameQuery) return;

      const nav = {name: this.$route.name, query};

      const op = replace
          ? this.$router.replace(nav)
          : this.$router.push(nav);

      return op.catch(err => {
        if (!err || err.name === 'NavigationDuplicated') return;
        throw err;
      });
    },
    changePerPage() {
      this.currentPage = 1
      this.persistStateToQuery(true)
      this.fetchProducts()
    },
    onProductSaved() {
      console.log('234234324')
      this.fetchProducts()
      this.showQuickCatalog = false
    },
    applyFilters() {
      this.currentPage = 1
      this.persistStateToQuery(true)
      this.fetchProducts()
    },
    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--
        this.persistStateToQuery(true)
        this.fetchProducts()
      }
    },
    nextPage() {
      if (this.currentPage * this.itemsPerPage < this.totalProducts) {
        this.currentPage++
        this.persistStateToQuery(true)
        this.fetchProducts()
      }
    },
    goToPage(page) {
      if (page !== '...') {
        this.currentPage = page
        this.persistStateToQuery(true)
        this.fetchProducts()
      }
    },
    startScrollRestore() {
      const shouldRestore = sessionStorage.getItem('adminProductListRestore') === '1'
      if (!shouldRestore) return
      const targetRaw = sessionStorage.getItem('adminProductListScroll')
      const target = Number(targetRaw || 0)
      if (isNaN(target)) {
        sessionStorage.removeItem('adminProductListRestore')
        return
      }
      let tries = 0
      const maxTries = 40
      const delay = 100
      const tryScroll = () => {
        const maxY = Math.max(0, (document.documentElement.scrollHeight || document.body.scrollHeight) - window.innerHeight)
        const y = Math.min(target, maxY)
        window.scrollTo(0, y)
        const ok = Math.abs((window.scrollY || window.pageYOffset) - y) < 2
        if (ok) {
          setTimeout(() => {
            const maxY2 = Math.max(0, (document.documentElement.scrollHeight || document.body.scrollHeight) - window.innerHeight)
            const y2 = Math.min(target, maxY2)
            window.scrollTo(0, y2)
            sessionStorage.removeItem('adminProductListRestore')
          }, 150)
          return
        }
        tries += 1
        if (tries < maxTries) {
          setTimeout(tryScroll, delay)
        } else {
          sessionStorage.removeItem('adminProductListRestore')
        }
      }
      setTimeout(tryScroll, 0)
    },
    async fetchProducts() {
      this.loading = true;
      const params = {
        limit: this.itemsPerPage,
        offset: (this.currentPage - 1) * this.itemsPerPage,
        ...this.filters
      };
      Object.keys(params).forEach(k => {
        if (params[k] === '') delete params[k]
      });
      this.request({
        url: this.endpoint('shop/adminProducts'),
        method: 'get',
        params,
        success: async (data) => {
          if (this.navigatingOut) return;

          this.products = data.results;
          this.totalProducts = data.count;
          this.ensureDefaultExpandedVariables();
          this.loading = false;
          await this.$nextTick();
          if (this.navigatingOut) return;
          await this.waitForImagesLoaded(this.$refs.listRoot || this.$el);
          if (this.navigatingOut) return;
          // if (this.initialProgressFromQuery != null && !this.appliedInitialProgress) {
          //   this._scrollContainer = this._getScrollContainer(this.$refs.listRoot || this.$el);
          //   this.scrollToProgress(this.initialProgressFromQuery, 'auto');
          //   this.appliedInitialProgress = true;
          //   this.clearProgressParam();
          // }
        },
        error: () => {
          this.loading = false;
        }
      });
    },
    restoreScrollOnce() {
      const targetRaw = sessionStorage.getItem('adminProductListScroll')
      const target = Number(targetRaw || 0)
      if (isNaN(target)) {
        sessionStorage.removeItem('adminProductListRestore')
        return
      }
      const start = performance.now()
      const maxMs = 3000 // حداکثر 3 ثانیه تلاش
      const tryScroll = () => {
        // وقتی محتوا کم باشد، از حد مجاز بالاتر نرویم
        const maxY = Math.max(
            0,
            (document.documentElement.scrollHeight || document.body.scrollHeight) - window.innerHeight
        )
        const y = Math.min(target, maxY)
        window.scrollTo(0, y)
        const ok = Math.abs((window.scrollY || window.pageYOffset) - y) < 2
        const timedOut = (performance.now() - start) > maxMs
        if (ok || timedOut) {
          setTimeout(() => {
            const maxY2 = Math.max(
                0,
                (document.documentElement.scrollHeight || document.body.scrollHeight) - window.innerHeight
            )
            const y2 = Math.min(target, maxY2)
            window.scrollTo(0, y2)
            sessionStorage.removeItem('adminProductListRestore')
            this.needRestore = false
          }, 120)
          return
        }
        requestAnimationFrame(tryScroll)
      }
      requestAnimationFrame(tryScroll)
    },
    showProductQuickView(product) {
      this.selectedProduct = product
      this.showQuickView = true
    },
    showProductQuickEdit(product) {
      this.selectedProductId = product.id
      this.showQuickEdit = true
    },
    showProductCatalog(product) {
      this.selectedProductId = product.id
      this.showQuickCatalog = true
    },
    fetchCategories() {
      this.request({
        url: this.endpoint('api/rootCategories'),
        method: 'get',
        success: (data) => {
          this.categories = data
        }
      })
    },
    fetchBrands() {
      this.request({
        url: this.endpoint('api/brands'),
        method: 'get',
        success: (data) => {
          this.brands = data
        }
      })
    },
    fetchCurrency() {
      this.request({
        url: this.endpoint('main/currency'),
        method: 'get',
        success: (data) => {
          this.currencies = data
        }
      })
    },
    resetFilters() {
      this.filters = {
        id_in: '',
        search_value: '',
        sku: '',
        min_price: '',
        max_price: '',
        min_inventory: '',
        max_inventory: '',
        category_tree: '',
        brand_in: '',
        status_in: '',
        content_status: '',
        catalog_need: '',
        currency_in: '',
        is_ai: null,
        supplier: ''
      };

      this.currentPage = 1;

      this.$router.replace({name: this.$route.name, query: {}});

      this.fetchProducts();
    },
    refreshProducts() {
      this.fetchProducts()
    },
    getStatusLabel(status) {
      const statusMap = {
        'draft': 'پیش نویس',
        'pr': 'نیاز به بررسی',
        'pending': 'در انتظار تایید',
        'publish': 'منتشر شده',
      }
      if (!status) return ' '
      return statusMap[status] || status
    },
    getContentStatusLabel(content_status) {
      const content_status_map = {
        'waiting': 'در انتظار محتوا',
        'done_pending': 'در انتظار تأیید',
        'approved': 'تأیید شده',
      }
      if (!content_status) return ' '
      return content_status_map[content_status] || content_status
    },
    getTypeLabel(type) {
      const typeMap = {
        'simple': 'ساده',
        'variable': 'دارای متغیر',
        'variation': 'متغیر',
      }
      if (!type) return ' '
      return typeMap[type] || type
    },
  },
  mounted() {
    this.loadStateFromQuery();
    this.fetchProducts();
    this.fetchAvails();
    this.fetchFeatures();
    this.fetchBrands();
    this.fetchCurrency();
    this.$nextTick(() => {
      this._scrollContainer = this._getScrollContainer(this.$refs.listRoot || this.$el);
      const target = this._scrollContainer === window ? window : this._scrollContainer;
      target.addEventListener('scroll', this._onScrollRaf, {passive: true});
    });
    document.addEventListener('click', this.handleGlobalClick);
    window.addEventListener('resize', this.closeActionMenu, {passive: true});
  },
  beforeDestroy() {
    const target = this._scrollContainer === window ? window : this._scrollContainer;
    if (target && target.removeEventListener) {
      target.removeEventListener('scroll', this._onScrollRaf);
    }
    window.removeEventListener('resize', this.closeActionMenu);
    document.removeEventListener('click', this.handleGlobalClick);
  },
  beforeRouteLeave(to, from, next) {
    this.navigatingOut = true;
    try {
      const sc = this._scrollContainer || this._getScrollContainer(this.$refs.listRoot || this.$el);
      const y = sc === window ? (window.scrollY || window.pageYOffset || 0) : sc.scrollTop;
      sessionStorage.setItem('adminProductListScroll', String(y));
      sessionStorage.setItem('adminProductListRestore', '1');
      const p = this._computeAndCacheProgress() || 0;
      sessionStorage.setItem('adminProductListProgress', String(Number(p.toFixed(3))));
    } catch (e) {
    }
    next();
  }
}
</script>
<style scoped>
td, th {
  color: rgba(255, 255, 255, 0.9) !important;
}

td p, td span, td div {
  color: rgba(255, 255, 255, 0.9) !important;
}

select.bg-gray-100 {
  background: rgba(15, 23, 42) !important;
  color: rgba(255, 255, 255, 0.9) !important;
  border: 1px solid rgba(255, 255, 255, 0.15) !important;
}

select option {
  background: rgba(15, 23, 42, 0.95) !important;
  color: rgba(255, 255, 255, 0.9) !important;
}

/* hover روی options */
select option:hover {
  background: rgba(99, 102, 241) !important;
}

.searchable-select {
  background: rgba(15, 23, 42, 0.8) !important;
  color: rgba(255, 255, 255, 0.9) !important;
  border: 1px solid rgba(255, 255, 255, 0.15) !important;
}

.searchable-select-dropdown {
  background: rgba(15, 23, 42, 0.95) !important;
  border: 1px solid rgba(255, 255, 255, 0.9) !important;
  backdrop-filter: blur(10px) !important;
}

/* items داخل dropdown */
.searchable-select-item {
  color: rgba(255, 255, 255, 0.9) !important;
}

.searchable-select-item:hover {
  background: rgba(99, 102, 241, 0.9) !important;
}

.text-gray-900 {
  color: rgba(255, 255, 255, 0.9) !important;
}

.text-gray-700, .text-gray-600 {
  color: rgba(255, 255, 255, 0.9) !important;
}

/* متن‌های خاکستری تیره‌تر */
.text-gray-500, .text-gray-400 {
  color: rgba(255, 255, 255, 0.5) !important;
}

body {
  direction: rtl;
  text-align: right;
}

/* ===== Dark Glass Theme Overrides (NO layout changes) ===== */

/* Page background that was: bg-white/60 */
.bg-white\/60 {
  background: rgba(2, 6, 23, 0.65) !important;
}

/* Cards that were: bg-white bg-opacity-70 (filters/table wrappers) */
.bg-white.bg-opacity-70 {
  background: rgba(2, 6, 23, 0.55) !important;
  backdrop-filter: blur(22px) saturate(140%) !important;
  -webkit-backdrop-filter: blur(22px) saturate(140%) !important;
  border-color: rgba(255, 255, 255, 0.10) !important;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.55),
  inset 0 1px 0 rgba(255, 255, 255, 0.06) !important;
}

/* Head / table header background that was: bg-gray-50 bg-opacity-70 */
.bg-gray-50.bg-opacity-70 {
  background: rgba(15, 23, 42, 0.60) !important;
}

/* Borders that were light */
.border-gray-100,
.border-gray-200,
.border-gray-300 {
  border-color: rgba(255, 255, 255, 0.08) !important;
}

/* Text colors: gray -> slate on dark */
.text-gray-800,
.text-gray-900 {
  color: rgba(226, 232, 240, 1) !important; /* slate-200 */
}

.text-gray-700,
.text-gray-600,
.text-gray-500,
.text-gray-400 {
  color: rgba(148, 163, 184, 1) !important; /* slate-400 */
}

/* Hover rows: hover:bg-gray-50 / bg-gray-100 / bg-gray-200 */
.hover\:bg-gray-50:hover {
  background: rgba(255, 255, 255, 0.04) !important;
}

.bg-gray-100 {
  background: rgba(255, 255, 255, 0.04) !important;
}

.bg-gray-200 {
  background: rgba(255, 255, 255, 0.06) !important;
}

/* Variable expanded row borders + background (your custom class string uses bg-gray-200) */
.border-t-4.border-t.border-gray-300.border-b.border-b-gray-300.bg-gray-200 {
  background: rgba(255, 255, 255, 0.7) !important;
  border-top-color: rgba(168, 85, 247, 0.35) !important; /* purple glow hint */
  border-bottom-color: rgba(255, 255, 255, 0.10) !important;
}

/* Inputs / selects that were bg-gray-100 and border default */
.bg-gray-100 {
  background: rgba(255, 255, 255, 0.06) !important;
}

input.bg-gray-100,
select.bg-gray-100,
textarea.bg-gray-100 {
  color: rgba(226, 232, 240, 1) !important;
  border-color: rgba(255, 255, 255, 0.10) !important;
}

input.bg-gray-100::placeholder,
textarea.bg-gray-100::placeholder {
  color: rgba(148, 163, 184, 0.75) !important;
}

input.bg-gray-100:focus,
select.bg-gray-100:focus,
textarea.bg-gray-100:focus {
  outline: none !important;
  box-shadow: 0 0 0 2px rgba(236, 72, 153, 0.25) !important; /* pink ring */
  border-color: rgba(236, 72, 153, 0.35) !important;
}

/* Buttons that were white */
.bg-white {
  background: rgba(255, 255, 255, 0.06) !important;
}

.hover\:bg-gray-50:hover {
  background: rgba(255, 255, 255, 0.08) !important;
}

/* Action button circles that were gray-400/300 etc */
.bg-gray-400 {
  background: rgba(255, 255, 255, 0.08) !important;
  border-color: rgba(255, 255, 255, 0.12) !important;
}

.hover\:bg-gray-300:hover {
  background: rgba(255, 255, 255, 0.10) !important;
}

/* Loading spinner color (was text-blue-500) */
.text-blue-500 {
  color: rgba(168, 85, 247, 1) !important; /* purple */
}

/* Pills (type/status/content) - keep same logic but make them darker/neon */
.bg-green-100 {
  background: rgba(16, 185, 129, 0.14) !important;
}

.text-green-800 {
  color: rgba(110, 231, 183, 1) !important;
}

.bg-blue-100 {
  background: rgba(59, 130, 246, 0.14) !important;
}

.text-blue-800 {
  color: rgba(147, 197, 253, 1) !important;
}

.bg-red-100 {
  background: rgba(239, 68, 68, 0.14) !important;
}

.text-red-800 {
  color: rgba(252, 165, 165, 1) !important;
}

.bg-yellow-100 {
  background: rgba(234, 179, 8, 0.14) !important;
}

.text-yellow-800 {
  color: rgba(253, 224, 71, 1) !important;
}

.bg-orange-100 {
  background: rgba(249, 115, 22, 0.14) !important;
}

.text-orange-800 {
  color: rgba(253, 186, 116, 1) !important;
}

.bg-gray-100.text-gray-800 {
  background: rgba(148, 163, 184, 0.10) !important;
  color: rgba(226, 232, 240, 0.95) !important;
}

/* Discount chip you have: bg-pink-300 text-pink-600 */
.bg-pink-300 {
  background: rgba(236, 72, 153, 0.18) !important;
}

.text-pink-600 {
  color: rgba(251, 113, 133, 1) !important;
}

/* Pagination active gradient (was blue-500/60 to blue-600/50) */
.bg-gradient-to-r.from-blue-500\/60.to-blue-600\/50 {
  background-image: linear-gradient(
      90deg,
      rgba(168, 85, 247, 0.55),
      rgba(236, 72, 153, 0.50),
      rgba(249, 115, 22, 0.45)
  ) !important;
  color: rgba(226, 232, 240, 1) !important;
}

/* Truncate helper you already had */
.truncate-text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100px;
}

/* keep your transition helper */
.transition-all {
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}

/* ===== Enhanced Glass Effect for Action Dropdown ===== */

/* Main dropdown container */
.bg-white\/20 {
  background: rgba(255, 255, 255, 0.10) !important;
}

.backdrop-blur-xl {
  backdrop-filter: blur(24px) saturate(180%) !important;
  -webkit-backdrop-filter: blur(24px) saturate(180%) !important;
}

.border-white\/30 {
  border-color: rgba(255, 255, 255, 0.25) !important;
}

.ring-white\/20 {
  --tw-ring-color: rgba(255, 255, 255, 0.2) !important;
}

/* Dropdown items */
.hover\:bg-gray-50:hover {
  background: rgba(255, 255, 255, 0.12) !important;
  backdrop-filter: blur(10px) !important;
  -webkit-backdrop-filter: blur(10px) !important;
}

/* Enhanced shadow for glass effect */
.shadow-2xl {
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.5),
  0 0 15px rgba(168, 85, 247, 0.2),
  inset 0 1px 0 rgba(255, 255, 255, 0.2) !important;
}

/* Smooth hover transitions for items */
.w-full.flex.items-center.gap-2.justify-start.px-3.py-2 {
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}

/* Icon colors - make them pop more */
.text-gray-600 {
  color: rgba(255, 255, 255, 0.8) !important;
}

/* Hover effects on text */
.hover\:bg-gray-50:hover span {
  color: rgba(255, 255, 255, 0.95) !important;
}

/* Separator line */
.border-t.border-gray-100.my-1 {
  border-color: rgba(255, 255, 255, 0.15) !important;
}

/* ===== Enhanced Glass Effect for Action Dropdown ===== */

/* Main dropdown container */
.bg-white\/20 {
  background: rgba(255, 255, 255, 0.10) !important;
}

.backdrop-blur-xl {
  backdrop-filter: blur(24px) saturate(180%) !important;
  -webkit-backdrop-filter: blur(24px) saturate(180%) !important;
}

.border-white\/30 {
  border-color: rgba(255, 255, 255, 0.25) !important;
}

.ring-white\/20 {
  --tw-ring-color: rgba(255, 255, 255, 0.2) !important;
}

.hover\:bg-gray-50:hover {
  background: rgba(255, 255, 255, 0.12) !important;
  backdrop-filter: blur(10px) !important;
  -webkit-backdrop-filter: blur(10px) !important;
}

.shadow-2xl {
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.5),
  0 0 15px rgba(168, 85, 247, 0.2),
  inset 0 1px 0 rgba(255, 255, 255, 0.2) !important;
}

/* Smooth hover transitions for items */
.w-full.flex.items-center.gap-2.justify-start.px-3.py-2 {
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}

/* Icon colors - make them pop more */
.text-gray-600 {
  color: rgba(255, 255, 255, 0.8) !important;
}

/* Hover effects on text */
.hover\:bg-gray-50:hover span {
  color: rgba(255, 255, 255, 0.95) !important;
}

/* Separator line */
.border-t.border-gray-100.my-1 {
  border-color: rgba(255, 255, 255, 0.15) !important;
}
</style>
